export default function SqlTablesCard() {
  return (
    <div className="ad-card">
      <div className="ad-card-header">
        <div className="ad-card-title">SQL Tables</div>
      </div>

      <div className="ad-empty">
        <div className="ad-empty-title">
          Select a company to load tables
        </div>
      </div>
    </div>
  );
}